export function readState() {
  return { loaded: false, pending: false, error: null, attempts: 0, nextAttemptAt: 0 }
}

// Each resource preserves its last successful value independently of other reads.
export function recoveringRead(read, commit, state, { now = Date.now } = {}) {
  const controller = new AbortController()
  let request = null
  let stopped = false
  return {
    run() {
      if (stopped || now() < state.nextAttemptAt) return Promise.resolve()
      if (request) return request
      state.pending = true
      request = Promise.resolve()
        .then(() => read(controller.signal))
        .then(value => {
          if (stopped) return
          commit(value)
          Object.assign(state, { loaded: true, error: null, attempts: 0, nextAttemptAt: 0 })
        })
        .catch(error => {
          if (stopped) return
          state.error = error
          state.attempts += 1
          const permanent = error?.status >= 400 && error.status < 500 && ![408, 425, 429].includes(error.status)
          state.nextAttemptAt = permanent ? Infinity : now() + Math.min(60_000, 2_000 * (2 ** Math.min(state.attempts - 1, 5)))
        })
        .finally(() => { state.pending = false; request = null })
      return request
    },
    stop() { stopped = true; controller.abort() },
  }
}
